import React, { Component } from 'react';
import { FormGroup, Input, Button, ListGroupItem, Container } from 'reactstrap';
import { Link } from 'react-router-dom';
import { SvgAssets } from '../../assets/icons/iconSvg';
import CounterInput from '../../components/reusable/CounterInput';
import Slider from "react-slick";
import c from '../../constants/Colors';
import product from '../../assets/img/product.png';
import Pagination from '../reusable/Pagination'
import { data } from '../../constants/Constants';
import localStorageCustom from '../../utilitarios/localStorage';
import { BuscarCodigoDescripcionPrincipal, BuscarCodigoDescripcion } from '../../store/sagas/pedidoApi';
import { AgregarProductoFavorito } from '../../store/sagas/favoritoApi';
import { AgregarProductoPedido } from '../../store/sagas/carritoApi';
import { notificacion, getStatePage } from '../../utilitarios/util';
import { AuthContext } from "../../store/provider/AuthProvider";
import ModalAddCart from "../reusable/modals/AddCart";
import ModalImageZoom from '../reusable/modals/ImageZoom';
import ModalImageZoom2 from '../reusable/modals/ImageZoom2';
import ModalCompatible from '../reusable/modals/Compatible';
import BtnCompatible from '../reusable/BtnCompatible';
import TooltipLeyenda from '../reusable/TooltipLeyenda';
import CardPrecios from '../reusable/CardPrecios';
import CardPrecioOferta from '../reusable/CardPrecioOferta';
import Spinner from "../reusable/Loader";

const CardOferta = ({ item, auth, event, eventCounter, zoom, compatible }) => {
  return (
    <div className="card_product_horizontal">
      <div className="cphLeftImage">
        {(item.modelos.length > 0) ?
          <button className='btn-icon'
            style={{ position: 'absolute', left: 6, top: 6 }}
            type="button"
            onClick={() => compatible(item.modelos)}
          >
            <SvgAssets icon="icon-compatible" fill={c.azulClaro} />
          </button> : null}
        <div style={{ cursor: 'pointer' }} onClick={() => zoom(item.fotos)}>
          <img src={item.pathImage} />
        </div>
      </div>
      <div className="cphTextCenter">
        <h6 className="paragraph-2 bold morado mb-1">{item.maktx}</h6>
        <span className="paragraph-3 mb-3" style={{ color: c.grisOscuro }}>SKU: {item.matnr}</span>
        {/* <span className="paragraph-3 previousPrice" style={{ color: c.grisOscuro }}>{item.precioPublico}</span>
        <strong className="paragraph-3 bold naranja">{item.precioPVD}</strong>
        <span className="paragraph-3">{item.precioPVP}</span> */}
        <CardPrecios data={item.precios} escalas={item.escalas} cantidad={item.cantidad} className="cardPrice" />

        <div className="options">
          {/* <BtnCompatible IdInput={item.idInput} texto={item.mensajeCompatible} /> */}

          <button className='btn-icon'>
            <SvgAssets icon="icon-trash" fill={c.celeste} />
          </button>
        </div>
      </div>
      <div className="cphCounterInput" style={{ backgroundColor: c.morado, justifyContent: 'space-between' }}>
        <CounterInput
          IdInput={item.idInput}
          vertical
          background={c.morado}
          color={"#fff"}
          borderColor={"#fff"}
          data={item}
          eventCounter={eventCounter}
        />
        <button
          className="btn-icon mt-3"
          disabled={item.cantidad == 0}
          onClick={() => event(auth.carritoProdctos, auth.setcarritoProdctos, {
            codigo: item.matnr,
            descripcion: item.maktx,
            precioOferta: item.poferta,
            precioPublico: item.plista,
            precioFinal: item.pfinal,
            unidadMedida: item.meins,
            precioPVD: item.precioPVD,
            precioPVP: item.precioPVP,
            precioPublico: item.precioPublico,
            moneda: item.waers,
            cantidadOriginal: item.cantidad,
            cantidad: item.cantidad,
            pantalla: data.Pantalla.BuscarPedidoCodigo.Producto,
            precios: item.precios,
            indice: item.indice,
            pathI: item.pathImage,
            escalas: item.escalas
          })}
        >
          <SvgAssets icon="icon-add-cart" />
        </button>
      </div>
    </div>
  )
}

const ProductoDestacado = ({ item, index, event, eventCounter, eventFavorito, auth, zoom, compatible }) => {
  return (
    <div className="card_product_vertical" style={{ marginRight: 10 }}>
      <div style={{ cursor: 'pointer' }} onClick={() => zoom(item.fotos)}>
        <img className="product-img" src={item.pathI} />
      </div>
      <h6 className="paragraph-2 bold azul">{item.maktx}</h6>
      <span className="paragraph-3 sku">SKU: {item.matnr}</span>
      {/* <span className="paragraph-3 previousPrice">{item.precioPublico}</span>
      <span className="paragraph-3 bold" style={{ color: c.naranja }}>{item.precioPVD}</span>
      <span className="paragraph-3">{item.precioPVP}</span> */}
      <CardPrecios data={item.precios} escalas={item.escalas} cantidad={item.cantidad} className="cardPrice" />
      <div className="counter">
        <CounterInput
          IdInput={item.idInput}
          background={"#fff"}
          color={"#316ACD"}
          borderColor={"#E2E2E2"}
          data={item}
          eventCounter={eventCounter}
        />
      </div>
      <div className="options">
        <BtnCompatible IdInput={item.idInput} texto={item.mensajeCompatible} />
        {/* <button className='btn-icon'
          type="button"
          onClick={() => compatible(item.mensajeCompatible)}
        >
          <SvgAssets icon="icon-compatible" fill={c.azulClaro} />
        </button> */}
        <button className="btn-icon"
          type="button"
          onClick={() => eventFavorito({
            codigo: item.matnr, descripcion: item.maktx,
            moneda: item.waers, pantalla: data.Pantalla.BuscarPedidoCodigo.Destacado
          }, item.favorito, item.indice)}
        >
          <SvgAssets icon="icon-star" fill={item.favorito ? c.amarillo : c.celeste} />
        </button>
        <button className="btn-icon"
          type="button"
          disabled={item.cantidad == 0}
          onClick={() => event(auth.carritoProdctos, auth.setcarritoProdctos, {
            codigo: item.matnr,
            descripcion: item.maktx,
            precioOferta: item.pOfe,
            precioPublico: item.pPub,
            precioFinal: item.pFin,
            precioPVD: item.precioPVD,
            precioPVP: item.precioPVP,
            precioPublico: item.precioPublico,
            unidadMedida: item.meins,
            moneda: item.waers,
            cantidadOriginal: item.cantidad,
            cantidad: item.cantidad,
            pantalla: data.Pantalla.BuscarPedidoCodigo.Destacado,
            precios: item.precios,
            indice: item.indice,
            pathI: item.pathI,
            escalas: item.escalas
          })}
        >
          <SvgAssets icon="icon-add-cart" className="add-cart" />
        </button>
      </div>
    </div>
  )
}

const ProductoVendido = ({ item, index, event, eventCounter, eventFavorito, auth, zoom }) => {
  return (
    <div className="card_product_horizontal gradient_blue" style={{ filter: 'none', height: '100%' }}>
      <div className="cphLeftImage">
        <div style={{ cursor: 'pointer' }} onClick={() => zoom(item.pathI)}>
          <img src={item.pathI} />
        </div>
      </div>
      <div className="cphTextCenter">
        <h6 className="paragraph-2 bold mb-1" style={{ color: '#fff' }}>{item.maktx}</h6>
        <span className="paragraph-3 mb-3" style={{ color: '#fff' }}>SKU: {item.matnr}</span>
        {/* <span className="paragraph-3 previousPrice" style={{ color: '#fff' }}>{item.precioPublico}</span>
        <strong className="paragraph-3 bold naranja">{item.precioPVD}</strong>
        <span className="paragraph-3" style={{ color: '#fff' }}>{item.precioPVP}</span> */}
        <CardPrecioOferta data={item.precios} className="cardPrice" />
        <div className="text-left mt-2">
          <button className='btn-icon' type="button"
            onClick={() => eventFavorito({
              codigo: item.matnr, descripcion: item.maktx,
              moneda: item.waers,
              cantidad: item.cantidad,
              pantalla: data.Pantalla.BuscarPedidoCodigo.Vendido
            }, item.favorito, item.indice)}
          >
            <SvgAssets icon="icon-star" fill={item.favorito ? c.amarillo : c.celeste} />
          </button>
        </div>
      </div>
      <div className="cphCounterInput" style={{ backgroundColor: c.azulClaro, justifyContent: 'space-between' }}>
        <CounterInput
          IdInput={item.idInput}
          vertical
          background={c.azulClaro}
          color={"#fff"}
          borderColor={"#fff"}
          data={item}
          eventCounter={eventCounter}
        />
        <div className="btn-link" disabled={item.cantidad == 0}
          onClick={() => event(auth.carritoProdctos, auth.setcarritoProdctos, {
            codigo: item.matnr,
            descripcion: item.maktx,
            precioOferta: item.pOfe,
            precioPublico: item.pPub,
            precioFinal: item.pFin,
            precioPVD: item.precioPVD,
            precioPVP: item.precioPVP,
            precioPublico: item.precioPublico,
            unidadMedida: item.meins,
            moneda: item.waers,
            cantidadOriginal: item.cantidad,
            cantidad: item.cantidad,
            pantalla: data.Pantalla.BuscarPedidoCodigo.Vendido,
            precios: item.precios,
            pathI: item.pathI,
            indice: item.indice,
            escalas: item.escalas
          })}
          style={{ marginTop: 20 }}>
          <SvgAssets icon="icon-add-cart" />
        </div>
      </div>
    </div>
  )
}

export class BuscadorCodigo extends Component {
  static displayName = BuscadorCodigo.name;
  static contextType = AuthContext;
  constructor(props) {
    super(props);
    this.state = {
      activeSlidePD: 0,
      activeSlidePV: 0,
      films: [],
      query: '',
      textBuscador: '',
      textBuscadorOri: '',
      loading: true,
      dataResult: { repuestos: [], destacados: [], vendidos: [] },
      page: 1,
      size: data.PageSizeVehiculos,
      currentPage: 1,
      dealer: {},
      linea: {},
      asociado: {},
      addToCart: false,
      dataToCard: {},
      errorCodigo: false,
      modalZoom: false,
      imgZoom: "",
      listImgZoom: [],
      modalCompatible: false,
      mensajeCompatible: '',
      dataCompatible: [],
    };
  }
  showModalCart = () => {
    this.setState(prevState => ({
      addToCart: !prevState.addToCart
    }));
  }
  toggleModalZoom = (img) => {
    this.setState(prevState => ({
      modalZoom: !prevState.modalZoom,
      imgZoom: Array.isArray(img) ? "" : img,
      listImgZoom: Array.isArray(img) ? img : [],
    }));
  }
  toggleModalCompatible = (texto) => {
    console.log("toggleModalCompatible===>", texto);
    this.setState(prevState => ({
      modalCompatible: !prevState.modalCompatible,
      dataCompatible: texto
    }));
  }
  showCarrito = () => {
    this.setState({ addToCart: false, loading: true }, () => {
      setTimeout(() => {
        this.setState({ loading: false })
        this.props.history.push('/carrito');
      }, 1000);
    });
  }
  checkParams(fn = () => { }) {
    const { state } = this.props.location;
    let datosBuscador = state != undefined ? state.datosBuscador : { text: this.state.textBuscador || '' };
    // let datosBuscador = state.datosBuscador;
    this.setState({ textBuscador: datosBuscador.text, textBuscadorOri: datosBuscador.text }, fn)
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.location.state !== this.props.location.state) {
      this.checkParams();
    }
  }

  componentDidMount() {
    if (getStatePage(this.props)) {
      window.scrollTo(0, 0)
      this.checkParams(() => {
        let data = localStorageCustom.prototype.getUsuario();
        this.setState({ dealer: data.dealer, linea: data.linea, asociado: data.asociado },
          this.IrBuscar)
        // this.postBuscarCodigoDescripcionPrincipal(data.dealer, data.linea, data.asociado, this.state.textBuscador);
      });
    } else
      window.location.href = "/";
  }

  render() {
    const navigation = this.props.navigation;
    const { errorCodigo, page, size, currentPage, loading, textBuscador, dataResult, activeSlidePD, activeSlidePV, query } = this.state;
    const films = this.findFilm(query);
    const auth = this.context;

    var slider_destacados = {
      dots: false,
      infinite: true,
      arrows: false,
      speed: 500,
      slidesToShow: 2,
      slidesToScroll: 1,
      variableWidth: true
    };
    var slider_vendidos = {
      dots: false,
      infinite: true,
      arrows: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
    };
    return (
      <div id="mhw">
        <Spinner visible={loading} />
        <form className="busqueda-pedido" style={{ backgroundColor: c.morado }}>
          <button
            className='btn-icon btn-close'
            type="button"
            onClick={() => { this.props.history.push('/generar-pedido') }}>
            <SvgAssets icon="icon-close" fill="#fff" />
          </button>
          <FormGroup className="mb-0">
            <Input type="text" name="descripcion"
              placeholder="SKU o Descripción"
              className="morado"
              value={textBuscador}
              onChange={(textBuscador) => this.setText(textBuscador)}
            />
            {/* <Link to="/buscador-codigo" style={{ textDecoration: 'none' }}>
              
            </Link> */}
            <button
              className='btn-icon rounded'
              type="button"
              onClick={() => { this.IrBuscar() }}>
              <SvgAssets icon="icon-lupa" fill="#fff" />
            </button>
          </FormGroup>
          {(errorCodigo) ? <p className="text-danger">Por favor ingrese un código SKU o Descripción del repuesto (al menos 5 caracteres)</p> : null}
        </form>
        <Container className="py-5" style={{ backgroundColor: '#fff', position: 'relative' }}>
          <SvgAssets icon="curve-bottom" className='curve-top' fill={c.morado} />
          <h6 className="title morado">Resultado obtenido:<TooltipLeyenda color={c.azulClaro} style={{ position: 'absolute', right: 0 }} /></h6>
          <div className="cards-wrap">
            {dataResult.repuestos.map((item, index) => {
              return (
                <CardOferta
                  key={index}
                  item={item}
                  event={this.postAgregarProductoPedido}
                  eventCounter={this.setCounter}
                  auth={auth}
                  zoom={this.toggleModalZoom}
                  compatible={this.toggleModalCompatible} />
              )
            })}
          </div>
          {(dataResult.repuestos.length > 0) ? <Pagination event={this.setPage} current={page} currentPage={currentPage} totalPage={dataResult.repuestos[0].totalPage} size={data.PageSizePaginator} /> : null}
          <SvgAssets icon="curve-bottom" className='curve-bottom' fill="#fff" />
        </Container>
        <Container className="py-5 productos_destacados" style={{ backgroundColor: c.azul, position: 'relative' }}>
          <h6 className="title" style={{ color: '#fff' }}>Productos destacados<TooltipLeyenda color={'#fff'} style={{ position: 'absolute', right: 0 }} /></h6>
          <Slider ref={c => (this.SLIDER_DESTACADOS = c)} {...slider_destacados}>
            {dataResult != null ?
              dataResult.destacados.map((carousel, index) => {
                return (
                  <ProductoDestacado key={index} item={carousel} index={index} event={this.postAgregarProductoPedido} eventCounter={this.setCounter} eventFavorito={this.postAgregarProductoFavorito} auth={auth} zoom={this.toggleModalZoom} compatible={this.toggleModalCompatible} />
                )
              })
              : null}
          </Slider>
          <div className="arrows-slider">
            <button className="btn-icon" onClick={() => this.SLIDER_DESTACADOS.slickPrev()}><SvgAssets icon="icon-left" fill='#fff' /></button>
            <button className="btn-icon" onClick={() => this.SLIDER_DESTACADOS.slickNext()}><SvgAssets icon="icon-right" fill='#fff' /></button>
          </div>
        </Container>
        <Container className="py-5" style={{ backgroundColor: "#fff", position: 'relative' }}>
          <h6 className="title" style={{ color: c.rojoClaro }}>Los Productos más comprados <TooltipLeyenda color={c.azulClaro} style={{ position: 'absolute', right: 0 }} /></h6>
          <Slider ref={c => (this.SLIDER_VENDIDOS = c)} {...slider_vendidos} className="dots_blue">
            {dataResult != null ?
              dataResult.vendidos.map((carousel, index) => {
                return (
                  <ProductoVendido key={index} item={carousel} index={index} event={this.postAgregarProductoPedido} eventCounter={this.setCounter} eventFavorito={this.postAgregarProductoFavorito} auth={auth} zoom={this.toggleModalZoom} />
                )
              })
              : null}
          </Slider>
          <div className="arrows-slider">
            <button className="btn-icon" onClick={() => this.SLIDER_VENDIDOS.slickPrev()}><SvgAssets icon="icon-left" fill={c.azulClaro} /></button>
            <button className="btn-icon" onClick={() => this.SLIDER_VENDIDOS.slickNext()}><SvgAssets icon="icon-right" fill={c.azulClaro} /></button>
          </div>
        </Container>
        <ModalAddCart dadComponent={this} dataToCard={this.state.dataToCard} />
        <ModalImageZoom2 dadComponent={this} />
        <ModalCompatible dadComponent={this} texto={this.state.mensajeCompatible} />
      </div>
    );
  }

  IrBuscar() {
    if (this.state.textBuscador == "" || this.state.textBuscador == null || this.state.textBuscador.length < data.BuscadorCodigoLongitud) {
      this.setState({
        errorCodigo: true
      })
    } else {
      this.setState({
        errorCodigo: false,
        loading: true
      }, () => {
        this.postBuscarCodigoDescripcionPrincipal(this.state.dealer, this.state.linea, this.state.asociado,
          this.state.textBuscador);
      })
    }
  }

  IrBuscador = async () => {
    this.props.navigation.navigate('GenerarPedido');
  }
  postAgregarProductoPedido = async (carritoProdctos, setcarritoProdctos, producto) => {
    this.setState({ loading: true })
    AgregarProductoPedido(this.state.dealer,
      producto,
      this.state.linea
    )
      .then(result => {
        if (result.mo.type == "success") {
          console.log("data producto", producto);
          let _repuestos = this.state.dataResult.repuestos
          let _destacados = this.state.dataResult.destacados
          let _vendidos = this.state.dataResult.vendidos

          if (producto.pantalla == data.Pantalla.BuscarPedidoCodigo.Destacado)
            _destacados[producto.indice].cantidad = 0;
          else if (producto.pantalla == data.Pantalla.BuscarPedidoCodigo.Vendido)
            _vendidos[producto.indice].cantidad = 0;
          else if (producto.pantalla == data.Pantalla.BuscarPedidoCodigo.Producto)
            _repuestos[producto.indice].cantidad = 0;


          this.setState({
            dataResult: {
              repuestos: _repuestos,
              destacados: _destacados,
              vendidos: _vendidos
            },
            loading: false,
            addToCart: true,
            dataToCard: producto
          })
          setcarritoProdctos(result.dto.carritoProdctos);
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await notificacion("Buscador", error.message ?? null);
        });
      });
  }

  postBuscarCodigoDescripcionPrincipal = (dealer, linea, asociado, textBuscador) => {

    BuscarCodigoDescripcionPrincipal(linea.centro, dealer.codcliente,
      textBuscador, asociado.moneda, linea.vkorg,
      asociado.poblacion, dealer.correoElectronico,
      this.state.page, data.Pantalla.BuscarPedidoCodigo.Producto,
      data.Pantalla.BuscarPedidoCodigo.Etiqueta.GenerarPedido)
      .then(result => {
        if (result.mo.type == "success") {
          this.setState({
            loading: false,
            dataResult: {
              repuestos: result.dto.repuestos,
              destacados: result.dto.productosDestacados,
              vendidos: result.dto.productosMasComprados
            }
          })

        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          notificacion("Buscador", error.message ?? null);
        });
      });
  }

  postBuscarCodigoDescripcion = (dealer, linea, asociado, textBuscador, indexPage) => {
    debugger;
    let _textBuscador = this.state.textBuscador;
    let _textBuscadorOri = this.state.textBuscadorOri;

    if (_textBuscador != _textBuscadorOri) {
      console.log("Reset a 1");
      this.setState({
        size: data.PageSize,
        currentPage: 1,
        page: 1,
        textBuscadorOri: _textBuscador
      })
      textBuscador = _textBuscador
      indexPage = 1
    }

    this.setState({ loading: true })
    BuscarCodigoDescripcion(linea.centro, dealer.codcliente,
      textBuscador, asociado.moneda, linea.vkorg,
      asociado.poblacion, dealer.correoElectronico,
      indexPage, data.Pantalla.BuscarPedidoCodigo.Producto)
      .then(result => {
        if (result.mo.type == "success") {
          let _data = this.state.dataResult;
          this.setState({
            loading: false,
            dataResult: {
              repuestos: result.dto.repuestos,
              destacados: _data.destacados,
              vendidos: _data.vendidos
            }
          })

        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          notificacion("Buscador", error.message ?? null);
        });
      });
  }
  postAgregarProductoFavorito = (producto, AplicaFavorito, index) => {
    this.setState({ loading: true })

    AgregarProductoFavorito(this.state.dealer, producto, this.state.linea, !AplicaFavorito
    )
      .then(result => {
        if (result.mo.type == "success") {
          this.setState({ loading: false })
          let _data = this.state.dataResult
          let _repuestos = _data.repuestos
          let _destacados = _data.destacados
          let _vendidos = _data.vendidos
          // _destacados[index].favorito = !AplicaFavorito;



          if (producto.pantalla == data.Pantalla.BuscarPedidoCodigo.Destacado)
            _destacados[index].favorito = !AplicaFavorito;
          else if (producto.pantalla == data.Pantalla.BuscarPedidoCodigo.Vendido)
            _vendidos[index].favorito = !AplicaFavorito;
          else if (producto.pantalla == data.Pantalla.BuscarPedidoCodigo.Producto)
            _repuestos[index].favorito = !AplicaFavorito;



          this.setState({
            dataResult: {
              repuestos: _repuestos,
              destacados: _destacados,
              vendidos: _vendidos
            }
          })

        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          notificacion("Buscador", error.message ?? null);
        });
      });
  }

  setCounter = (counter, tab, index) => {
    let _data = this.state.dataResult
    let _repuestos = _data.repuestos
    let _destacados = _data.destacados
    let _vendidos = _data.vendidos
    if (counter == "") {
      if (data.Pantalla.BuscarPedidoCodigo.Producto == tab)
        _repuestos[index].cantidad = 0;
      else if (data.Pantalla.BuscarPedidoCodigo.Destacado == tab)
        _destacados[index].cantidad = 0;
      else if (data.Pantalla.BuscarPedidoCodigo.Vendido == tab)
        _vendidos[index].cantidad = 0;
    } else {
      if (data.Pantalla.BuscarPedidoCodigo.Producto == tab)
        _repuestos[index].cantidad = counter;
      else if (data.Pantalla.BuscarPedidoCodigo.Destacado == tab)
        _destacados[index].cantidad = counter;
      else if (data.Pantalla.BuscarPedidoCodigo.Vendido == tab)
        _vendidos[index].cantidad = counter;
    }





    this.setState({
      dataResult: {
        repuestos: _repuestos,
        destacados: _destacados,
        vendidos: _vendidos
      }
    })

  }
  setActiveSlidePD = (index) => {
    this.setState({ activeSlidePD: index })
  }

  setActiveSlidePV = (index) => {
    this.setState({ activeSlidePV: index })
  }
  setText = (e) => {
    let value = e.currentTarget.value;
    this.setState({ textBuscador: value })
  }
  setPage = (index, change, type) => {
    if (change) {
      let _currentPage = this.state.currentPage
      this.setState({ page: index, currentPage: type == "add" ? (_currentPage + 1) : (_currentPage - 1) })
    }
    else
      this.setState({ page: index })

    console.log("Pagina indice", index);

    this.postBuscarCodigoDescripcion(this.state.dealer, this.state.linea, this.state.asociado, this.state.textBuscador, index);

  }
  // componentDidMount() {
  //   fetch(`${API}/films/`).then(res => res.json()).then((json) => {
  //     const { results: films } = json;
  //     this.setState({ films });
  //   });
  // }
  findFilm(query) {
    if (query === '') {
      return [];
    }

    const { films } = this.state;
    const regex = new RegExp(`${query.trim()}`, 'i');
    return films.filter(film => film.title.search(regex) >= 0);
  }
}
